import { useQuery } from '@tanstack/react-query';
import { api } from '../../../lib/api';
import type { Ohlc } from '../ui/Sparkline';

type KlineRow = {
  open_time?: number;
  open: number | string;
  high: number | string;
  low: number | string;
  close: number | string;
  volume?: number | string;
};

export function useKlines(symbol = 'BTCUSDT', interval = '1h', limit = 48) {
  return useQuery({
    queryKey: ['klines', symbol, interval, limit],
    queryFn: async () => {
      const res = await api.get<{ klines?: KlineRow[]; symbol?: string; ok?: boolean }>(
        `/api/binance/klines?symbol=${symbol}&interval=${interval}&limit=${limit}`,
      );
      const klines = res.klines || [];
      const candles: Ohlc[] = klines
        .map((k) => ({
          open: Number(k.open),
          high: Number(k.high),
          low: Number(k.low),
          close: Number(k.close),
        }))
        .filter((c) => Number.isFinite(c.close));
      const closes = candles.map((c) => c.close);
      return { candles, closes, symbol: res.symbol || symbol };
    },
    retry: 1,
    staleTime: 60_000,
    refetchInterval: 60_000,
  });
}
